import type { LabVisibility } from './types';

const VISIBILITY_LABELS: Record<LabVisibility, string> = {
  private: 'Project team',
  unit: 'Unit',
  organization: 'University',
};

const EVENT_LABELS: Record<string, string> = {
  submitted: 'Submitted',
  approved: 'Approved',
  changes_requested: 'Changes requested',
  published: 'Published',
  withdrawn: 'Submission cancelled',
  taken_down: 'Taken down',
};

export function visibilityLabel(visibility: LabVisibility): string {
  return VISIBILITY_LABELS[visibility];
}

export function eventLabel(action: string): string {
  return EVENT_LABELS[action] ?? action;
}

export function platformFamily(platform: string): string {
  if (platform.startsWith('windows')) return 'Windows';
  if (platform.startsWith('mac')) return 'macOS';
  return 'Linux';
}

export function platformFamilies(platforms: string[]): string[] {
  return [...new Set(platforms.map(platformFamily))];
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatDate(value: string | null): string {
  if (!value) return '';
  return new Date(value).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function downloadTextFile(filename: string, contentType: string, body: string): void {
  const url = URL.createObjectURL(new Blob([body], { type: contentType }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
